import React, { useState, useEffect } from "react";
import { Box, Typography, Card, useTheme, Container } from "@mui/material";
import PositionsTable from "./PositionsTable";
import { getBoxedPositions } from "../../utils/helpers";
import { Helmet } from "react-helmet";
import { usePositionsState } from "../../hooks/useOptimizedState";
const BoxedPositions = () => {
  const theme = useTheme();
  const { funds, lots, strategies, custodians, managers } = usePositionsState();

  const [positions, setPositions] = useState([]);
  const [filteredPositions, setFilteredPositions] = useState([]);
  // Filter out SMA funds and lots
  const smaList = Object.keys(managers[0]?.smas || {});
  const filteredFunds =
    funds?.filter((fund) => !smaList?.includes(fund?.fundId)) || [];
  const filteredLots =
    lots?.filter((lot) => !smaList?.includes(lot?.fund)) || [];

  useEffect(() => {
    if (filteredLots && custodians) {
      const positionsData = getBoxedPositions(filteredLots, custodians);
      setPositions(positionsData);
      setFilteredPositions(positionsData);
    }
  }, [filteredLots, custodians]);

  return (
    <>
      <Helmet>
        <title>Boxed Positions | Vantage Alpha</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: theme.palette.grey[50],
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                mb: 1,
              }}
            >
              Boxed Positions
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.secondary,
              }}
            >
              View and manage boxed positions across funds
            </Typography>
          </Box>

          <Card
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              border: `1px solid ${theme.palette.divider}`,
            }}
          >
            <PositionsTable 
              positions={filteredPositions}
              originalPositions={positions}
              funds={filteredFunds}
              strategies={strategies}
              custodians={custodians}
            />
          </Card>
        </Container>
      </Box>
    </>
  );
};

export default BoxedPositions; 